import { useEffect, useState } from "react";
import VipStatCard from "../components/VipStatCard";
import VipTable from "../components/VipTable";
import FilterBar from "../components/FilterBar";

const EMPTY_DATA = {
  totalVip: 0,
  totalSales: 0,
  totalPoints: 0,
  customers: []
};

export default function Vip() {
  const [data, setData] = useState(EMPTY_DATA);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/vip/summary")
      .then(res => res.json())
      .then(json => {
        setData(json.data || EMPTY_DATA);
      })
      .catch(err => {
        console.error("VIP API error", err);
        setData(EMPTY_DATA);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="p-6">Loading VIP...</div>;
  }

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">
      <FilterBar />

      {/* Stat Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <VipStatCard
          title="ลูกค้า VIP ทั้งหมด"
          value={data.totalVip}
          subtitle="จำนวนลูกค้า VIP"
        />
        <VipStatCard
          title="ยอดซื้อรวม"
          value={`฿${data.totalSales.toLocaleString()}`}
          subtitle="ยอดซื้อสะสมทั้งหมด"
        />
        <VipStatCard
          title="คะแนนรวม"
          value={data.totalPoints.toLocaleString()}
          subtitle="คะแนนสะสมทั้งหมด"
        />
      </div>

      {/* Table */}
      <VipTable data={data.customers} />

    </div>
  );
}
